<nav
  class="navbar navbar-expand-lg navbar-light border-bottom bg-gradient topbarnav shadow mb-1 sticky-navbar w-100 p-0 fixed-header text-icon fixed-top home-nav-primary-border">
  <div class="container-fluid d-flex justify-content-between ">
    <!-- Left Section: Sidebar Toggle, Logo -->
    <div class="d-flex align-items-center">
      <!-- Logo -->
      <a
        v-if="vettedsa_domain"
        class="navbar-brand fs-4 fw-bolder text-black d-none d-md-flex flex-column align-items-center vettedsa-navbar-brand"
        href="/home"
      >
        <img :src="$clientLogo" alt="Vetted SA Logo" class="logo object-fit-contain pointer">
        <span class="small mb-0 logo-title">Vetted SA</span>
        <p class="logo-subtitle mb-0 fst-italic">Trust Local. Shop Smarter.</p>
      </a>
      <a v-else class="d-flex align-items-center d-none d-md-flex pointer" href="/home">
        <img :src="navbar_logo" class="img-fluid logo pointer" alt="Logo" @error="handle_navbar_logo_error" />
      </a>
 
  <!-- Mobile Logo -->
      <a
        v-if="vettedsa_domain"
        class="navbar-brand fs-4 fw-bolder text-black d-flex d-md-none flex-column align-items-center flex-shrink-0 vettedsa-navbar-brand vettedsa-navbar-brand-mobile"
        :class="{ 'd-none': show_search }"
        href="/home"
      >
        <img :src="$clientLogo" alt="Vetted SA Logo" class="mobile-logo object-fit-contain pointer">
        <span class="small mb-0 logo-title">Vetted SA</span>
        <p class="logo-subtitle mb-0 fst-italic">Trust Local. Shop Smarter.</p>
      </a>
      <a v-else class="d-flex align-items-center d-flex d-md-none flex-shrink-0" :class="{ 'd-none': show_search }" href="/home">
        <img :src="navbar_logo" class="img-fluid mobile-logo" alt="Logo" @error="handle_navbar_logo_error" />
      </a>
      <span
        v-if="client_features?.show_organisation && workspace_community_name"
        class="home-nav-mobile-organization-name d-none text-dark fw-bold text-truncate"
        :class="{ 'd-none': show_search }"
      >
        {{ workspace_community_name }}
      </span>
    </div>
 
    <!-- Center Section: Search Bar (Desktop) -->
        <div class=" d-none d-lg-flex flex-grow-1 justify-content-center position-relative">
  <input v-if="token_exists" v-model="search_query" type="text"
         class="form-control text-xxs search-input  rounded-pill p-2 shadow" placeholder="Search..." @click="show_recent" @keydown.enter.prevent="go_to_unified_search" />
 
    <div v-if="search_query && filtered_profiles" class="mt-5 position-absolute w-100 search-bar">
      <div class="d-flex justify-content-between align-items-center bg-white border-bottom px-3 py-2 rounded-top">
        <small class="text-muted fw-bold">Search</small>
        <button
          type="button"
          class="btn btn-sm border-0 d-flex align-items-center justify-content-center"
          aria-label="Close search results"
          @click.stop="clear_search_dropdown"
        >
          <i class="bi bi-x-lg home-nav-search-x"></i>
        </button>
      </div>
      <ul v-if="!is_loading || (search_query)"
        class="list-group scroll-container h-50 border-0 rounded-bottom text-xxs">

          <!-- Recent Searches -->
          <li v-if="filtered_recent.length" class="list-group-item bg-light">
            <small class="text-muted fw-bold">Recent Searches</small>
          </li>
          <li
            v-if="filtered_recent.length > 0"
            v-for="history in filtered_recent"
            :key="`history-${history.id}`"
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center gap-2">
              <i class="ms-3 bx bx-history text-secondary fs-3"></i>
              <a @click="apply_history(history.query)" class="text-decoration-none text-dark">
                {{ history.query }}
              </a>
            </div>
            <button
              class="btn btn-sm btn-light text-danger border-0"
              @click.stop="remove_history(history.id)"
            >
              <i class="bx bx-x"></i>
            </button>
          </li>
 
          <!-- People Header -->
          <li v-if="filtered_profiles.profiles?.length" class="list-group-item bg-light">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted fw-bold">People</small>
              <small
                v-if="filtered_profiles.profiles.length > 3"
                class="text-primary pointer"
                @click="toggle_expand('people')"
              >
                {{ expanded_section === 'people' ? 'View Less' : 'View More' }}
              </small>
            </div>
          </li>
          <!-- People -->
          <li
            v-for="profile in visible_profiles"
            :key="`profile-${profile.id}`"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3">
              <i class="bx bxs-user-circle text-secondary fs-2"></i>
              <div class="d-flex flex-column">
                <a @click="view_profile(profile)" class="text-decoration-none text-dark">
                  {{ profile.user.first_name }} {{ profile.user.last_name }}
                </a>
                <small class="text-muted">{{ profile?.user.email || '' }}</small>
              </div>
            </div>
          </li>
 
          <!-- Companies Header -->
          <li v-if="filtered_profiles.companies?.length" class="list-group-item bg-light">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted fw-bold">Companies</small>
              <small
                v-if="filtered_profiles.companies.length > 3"
                class="text-primary pointer"
                @click="toggle_expand('companies')"
              >
                {{ expanded_section === 'companies' ? 'View Less' : 'View More' }}
              </small>
            </div>
          </li>
          <!-- Companies -->
          <li
            v-for="company in visible_companies"
            :key="`company-${company.id}`"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3">
              <i class="bx bxs-briefcase text-secondary fs-2"></i>
              <div class="d-flex flex-column">
                <a @click="view_profile(company)" class="text-decoration-none text-dark">
                  {{ company.company_name }}
                </a>
                <small class="text-muted">{{ company?.location || '' }}</small>
              </div>
            </div>
          </li>
 
          <!-- Portals Header -->
          <li v-if="filtered_profiles.portals?.length" class="list-group-item bg-light">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted fw-bold">Portals</small>
              <small
                v-if="filtered_profiles.portals.length > 3"
                class="text-primary pointer"
                @click="toggle_expand('portals')"
              >
                {{ expanded_section === 'portals' ? 'View Less' : 'View More' }}
              </small>
            </div>
          </li>
          <!-- Portals -->
          <li
            v-for="portal in visible_portals"
            :key="`portal-${portal.id}`"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3">
              <i class="bx bx-globe text-secondary fs-2"></i>
              <div class="d-flex flex-column">
                <a @click="view_portal(portal)" class="text-decoration-none text-dark">
                  {{ portal.portal_name || portal.name }}
                </a>
                <small class="text-muted">{{ portal?.description || '' }}</small>
              </div>
            </div>
          </li>
 
          <!-- Reports Header -->
          <li v-if="filtered_profiles.reports?.length" class="list-group-item bg-light">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted fw-bold">Reports</small>
              <small
                v-if="filtered_profiles.reports.length > 3"
                class="text-primary pointer"
                @click="toggle_expand('reports')"
              >
                {{ expanded_section === 'reports' ? 'View Less' : 'View More' }}
              </small>
            </div>
          </li>
          <!-- Reports -->
          <li
            v-for="report in visible_reports"
            :key="`report-${report.id}`"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3" @click="view_report(report)">
              <i class="bx bx-file text-secondary fs-2"></i>
              <div class="d-flex flex-column">
                <a  class="text-decoration-none text-dark">
                  <span v-html="displayed_description(report)"></span>
                </a>
                <small class="text-muted mt-2">
                  Tags:
                  <span>
                    {{ display_tags(report.tags).join(', ') }}
                    <span v-if="!search_query && report.tags.length > 2">...</span>
                  </span>
                </small>
              </div>
            </div>
          </li>

          <li v-if="filtered_profiles.products?.length" class="list-group-item bg-light">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted fw-bold">Products</small>
              <small
                v-if="filtered_profiles.products.length > 3"
                class="text-primary pointer"
                @click="toggle_expand('products')"
              >
                {{ expanded_section === 'products' ? 'View Less' : 'View More' }}
              </small>
            </div>
          </li>
          <!-- Products -->
          <li
            v-for="product in visible_products"
            :key="`product-${product.id}`"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3 pointer" @click="view_product_details(product)">
              <img
                :src="product.images?.length ? product.images[0].image_url : require('@/assets/images/image_placeholder.jpg')"
                :alt="product.name || 'Product image'"
                class="profile-image rounded profile-list-avatar object-fit-cover flex-shrink-0 mt-2"
              >
              <div class="d-flex flex-column">
                <a class="text-decoration-none text-dark">
                  <!-- Ensure you use the correct property for your product's name (e.g., name or title) -->
                  {{ product.name }}
                </a>
              </div>
            </div>
          </li>
 
          <!-- Loading -->
          <li v-if="is_loading" class="list-group-item text-center">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </li>
 
          <!-- Empty -->
          <li
            v-else-if="!filtered_profiles.profiles?.length && !filtered_profiles.companies?.length && !filtered_profiles.portals?.length && !filtered_profiles.reports?.length && !filtered_profiles.products?.length && !filtered_profiles.tags?.length && search_query"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3">
              <i class="bx bx-search-alt text-primary fs-2"></i>
              <div class="d-flex flex-column">
                <span class="text-muted">No results found</span>
              </div>
            </div>
          </li>
 
        </ul>
      </div>
 
 
</div>

 
 
 
    <!-- Right Section: Icons, Notifications, and User Menu -->
    <div class="home-nav-actions d-flex align-items-center" :class="{ 'flex-grow-1': show_search }">
      <a class="home-nav-action d-flex align-items-center justify-content-center text-decoration-none text-dark text-xxs fw-500 d-md-flex" :class="{ 'd-none': show_search }" v-if="!is_home_page "
        :href="vettedsa_domain ? '/marketplace' : '/home'">
      <i class="bi bi-house-door-fill fs-2 text-dark"></i>
    </a>

      <input
        v-model="search_query"
        type="text"
        class="form-control p-1 mx-1 text-dark rounded-5 shadow-sm text-xs"
        style="min-width: 0;"
        v-if="show_search"
        placeholder="Search..."
        @click="show_recent"
        @keydown.enter.prevent="go_to_unified_search"
      />
      <button
        v-if="show_search"
        type="button"
        class="btn btn-sm border-0 d-flex align-items-center justify-content-center"
        aria-label="Clear search"
        @click.stop="clear_search_dropdown"
      >
        <i class="bi bi-x-lg home-nav-search-x"></i>
      </button>
      <a v-if="token_exists" class="home-nav-action align-items-center justify-content-center text-decoration-none text-dark text-xxs fw-500 d-none d-md-flex" :class="{ 'd-none': show_search }" @click="toggle_menu">
        <i class="bi bi-grid-fill fs-3"></i>
        </a>

      <!-- Mobile Search Icon -->
      <div v-if="token_exists" class="home-nav-action d-flex d-lg-none align-items-center justify-content-center position-relative" :class="{ 'd-none': show_search }">
        <i class="bx bx-search-alt-2 fs-1 fw-bold mt-1"   @click="toggle_search"></i>

      </div>
 
 
    <!-- Menu Icon Button -->
  
      <!-- Dropdown inside navbar -->
      <div v-if="show_menu" class="menu-dropdown ms-0 me-5 mt-1 shadow">
        <MenuSideBar />
      </div>
      <div v-if="client_features.show_marketplace" class="home-nav-action d-flex align-items-center justify-content-center" :class="{ 'd-none': show_search }">
      <Cart ref="cartRef"/>
      </div>

      <div class="home-nav-action d-none d-xl-flex" :class="{ 'd-none': show_search }">
        <NotificationDropdown
          ref="notificationDropdown"
          @notification-count-updated="update_notification_count"
        />
      </div>

      <!-- User Menu -->
      <ul class="home-nav-action navbar-nav d-flex flex-row justify-content-center text-xxs fw-500"
        :class="{ 'd-none': show_search }"
        v-if="token_exists">
        <li class="nav-item" >
          <a class="nav-link d-flex align-items-center justify-content-center" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">
            <div v-if="base_profiles.find(profile => is_base_profile_active(profile))?.profile_files?.length"
              class="profile-list-avatar pointer">
            <img
              :src="base_profiles.find(profile => is_base_profile_active(profile)).profile_files[0].file.file_url"
              alt="Profile Image"
              class="d-block rounded profile-image pointer">
          </div>
          <div v-else class="me-2 ms-1 d-flex align-items-center justify-content-center ">
            <i class="bi bi-person-circle fs-2 text-dark pointer">
              
            </i>
          </div>
          </a>
 
       <div class="offcanvas offcanvas-end home-nav-offcanvas bg-light border-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
  <div class="offcanvas-header home-nav-offcanvas-header bg-white border-bottom px-4 py-3">
    <div>
      <span class="home-nav-offcanvas-kicker d-flex align-items-center gap-1 text-muted text-uppercase fw-bold lh-1">
        <span>Workspace</span>
        <span v-if="client_features?.show_organisation && workspace_community_name" class="text-muted text-capitalize">&middot; {{ workspace_community_name }}</span>
      </span>
      <h6 class="home-nav-offcanvas-title text-dark fw-bold mb-0 mt-1" id="offcanvasExampleLabel">Profiles & Settings</h6>
    </div>
    <button type="button" class="btn-close text-reset home-nav-offcanvas-close rounded-circle bg-light opacity-100" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body home-nav-offcanvas-body d-flex flex-column gap-3 p-3">
    <section class="home-nav-menu-section d-flex flex-column gap-1" v-if="user_details?.user_role!='organization admin' &&(visible_base_profiles.some(profile => matches_profile_type(profile, 'personal')))">
      <div class="home-nav-menu-heading d-flex align-items-center justify-content-between px-1 text-muted text-xxs fw-bold text-uppercase lh-1">
        <span>Main Profile</span>
      </div>
      <button
        v-for="base_profile in visible_base_profiles.filter(profile => matches_profile_type(profile, 'personal'))"
        :key="base_profile.id"
        type="button"
        class="home-nav-profile-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        :class="{ active: is_base_profile_active(base_profile) }"
        @click.prevent="control_switching_profile(base_profile); close_home_nav_offcanvas()"
      >
        <span class="home-nav-profile-avatar flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center overflow-hidden">
          <img
            v-if="base_profile.profile_files?.length"
            :src="base_profile.profile_files[0].file.file_url"
            alt="Profile Picture"
          >
          <img v-else src="@/assets/images/user.png" alt="User Icon">
        </span>
        <span class="home-nav-profile-copy min-w-0 flex-grow-1 d-flex flex-column lh-sm">
          <strong class="text-dark fw-500 text-xxs">{{ base_profile.profile_name || user_details.first_name }}</strong>
          <small class="text-muted fw-500">Personal profile</small>
        </span>
        <i v-if="is_base_profile_active(base_profile)" class="bx bx-check home-nav-profile-check ms-auto text-primary"></i>
      </button>
    </section>

    <section class="home-nav-menu-section d-flex flex-column gap-1" v-if="visible_base_profiles.some(profile => matches_profile_type(profile, 'business')) && can_show_business_profiles">
      <div class="home-nav-menu-heading d-flex align-items-center justify-content-between px-1 text-muted text-xxs fw-bold text-uppercase lh-1">
        <span>Business Profiles</span>
      </div>
      <button
        v-for="base_profile in visible_base_profiles.filter(profile => matches_profile_type(profile, 'business'))"
        :key="base_profile.id"
        type="button"
        class="home-nav-profile-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        :class="{ active: is_base_profile_active(base_profile) }"
        @click.prevent="control_switching_profile(base_profile); close_home_nav_offcanvas()"
      >
        <span class="home-nav-profile-avatar business flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center overflow-hidden text-primary">
          <img
            v-if="base_profile.profile_files?.length"
            :src="base_profile.profile_files[0].file.file_url"
            alt="Business Profile Picture"
          >
          <i v-else class="bi bi-building"></i>
        </span>
        <span class="home-nav-profile-copy min-w-0 flex-grow-1 d-flex flex-column lh-sm">
          <strong class="text-dark fw-500 text-xxs">{{ base_profile.profile_name || user_details.first_name }}</strong>
          <small class="text-muted fw-500">Business profile</small>
        </span>
        <i v-if="is_base_profile_active(base_profile)" class="bx bx-check home-nav-profile-check ms-auto text-primary"></i>
      </button>
    </section>

    <section class="home-nav-menu-section d-flex flex-column gap-1" v-if="visible_domain || cbo_domain">
      <div class="home-nav-menu-heading d-flex align-items-center justify-content-between px-1 text-muted text-xxs fw-bold text-uppercase lh-1">
        <span>Business Tools</span>
      </div>
      <button
        v-if="can_create_business_profile"
        class="home-nav-menu-row primary w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        @click="open_company_profile_modal"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-briefcase"></i></span>
        <span class="text-dark fw-500 text-xxs">Create Business Profile</span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>

      <button
        v-if="visible_base_profiles.some(profile => matches_profile_type(profile, 'business'))"
        class="home-nav-menu-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        @click="open_manage_business"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bx bx-cog"></i></span>
        <span class="text-dark fw-500 text-xxs">Manage Business</span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>

      <button
        class="home-nav-menu-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        @click="$router.push('/my_orders'); close_home_nav_offcanvas()"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-bag-check"></i></span>
        <span class="text-dark fw-500 text-xxs">My Orders/Requests</span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>
    </section>

    <section class="home-nav-menu-section d-flex flex-column gap-1">
      <div class="home-nav-menu-heading d-flex align-items-center justify-content-between px-1 text-muted text-xxs fw-bold text-uppercase lh-1">
        <span>Account</span>
      </div>
      <button
        v-if="token_exists && is_organization_only_session"
        class="home-nav-menu-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        @click="$router.push('/home_filter/'); close_home_nav_offcanvas()"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bx bx-cog"></i></span>
        <span class="text-dark fw-500 text-xxs">Settings</span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>
      <button
        class="home-nav-menu-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#notificationSettingsModal"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bx bx-bell"></i></span>
        <span class="text-dark fw-500 text-xxs">Manage Notifications</span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>

      <button class="home-nav-menu-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start" type="button" @click="confirm_deactivation(); close_home_nav_offcanvas()">
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bx bx-user-x"></i></span>
        <span class="text-dark fw-500 text-xxs">Deactivate Account</span>
      </button>
        <button v-if="client_features.show_membership" class="home-nav-menu-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start" type="button" @click=go_to_view_membership>
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-credit-card"></i></span>
        <span class="text-dark fw-500 text-xxs">Subscription</span>
      </button>
      <button class="home-nav-menu-row danger w-100 border rounded bg-white text-danger d-flex align-items-center gap-3 text-start" type="button" @click="confirm_account_deletion(); close_home_nav_offcanvas()">
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-danger"><i class="bx bx-trash"></i></span>
        <span class="fw-500 text-xxs">Delete Account</span>
      </button>

      <button class="home-nav-menu-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start" type="button" @click="logout_user(); close_home_nav_offcanvas()">
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bx bx-log-out"></i></span>
        <span class="text-dark fw-500 text-xxs">Log Out</span>
      </button>
    </section>

  </div>
</div>
        </li>
 
        <li class="nav-item no-arrow mt-1 d-none">
          <!-- Profile Avatar Trigger with Notification Badge -->
          <a class="nav-link dropdown-toggle d-flex align-items-center" href="#" id="messages_dropdown"
            role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div v-if="base_profiles.find(profile => is_base_profile_active(profile))?.profile_files?.length"
              class="me-2 profile-list-avatar">
            <img
              :src="base_profiles.find(profile => is_base_profile_active(profile)).profile_files[0].file.file_url"
              alt="Profile Image"
              class="d-block rounded profile-image pointer">
          </div>
            <div v-else class="me-2 d-flex align-items-center justify-content-center  mb-1">
              <i class="bi bi-person-circle fs-2 text-dark pointer">
                
              </i>
            </div>
          </a>
 
          <!-- Extended Dropdown Menu -->
          <div class="dropdown-menu dropdown-menu-end shadow border-0 p-0 profile-dropdown-menu">
 
            <!-- User Profile Section -->
            <div class="p-3 border-bottom">
              <!-- -->
 
              <div class="mb-2">
                <!-- Personal Profiles -->
                <h6 class="dropdown-header text-muted">Main Profiles</h6>
                <div
                  v-for="base_profile in visible_base_profiles.filter(profile => matches_profile_type(profile, 'personal'))"
                  :key="base_profile.id">
                  <a href="#" @click.prevent="control_switching_profile(base_profile)"
                    class="d-flex align-items-center gap-3 text-decoration-none text-dark p-2 rounded hover-bg-light">
                     <div class="profile-list-avatar">
 
                      <!-- Loop through profile_files and show all images -->
                      <div v-if="base_profile.profile_files?.length">
                        <img v-for="file in base_profile.profile_files"
                            :key="file.id"
                            :src="file.file.file_url"
                            class="profile-image rounded"
                            alt="Profile Picture">
                      </div>
                      <div v-else class="me-2 ms-2 d-flex align-items-center justify-content-center">
                        <i class="bi bi-person-circle fs-3 text-dark pointer">

                        </i>
                      </div>
                    </div>
                    <span class="text-xxs mb-2">{{ base_profile.profile_name || user_details.first_name }}</span>
                    <i v-if="is_base_profile_active(base_profile)" class="bx bx-check text-primary ms-auto"></i>
                  </a>
                </div>
 
                <!-- Business Profiles -->
                <h6 v-if="can_show_business_profiles && visible_base_profiles.filter(profile => matches_profile_type(profile, 'business')).length >0 " class="dropdown-header text-muted mt-3">Business Profiles</h6>

                <div v-if="can_show_business_profiles"
                  v-for="base_profile in visible_base_profiles.filter(profile => matches_profile_type(profile, 'business'))"
                  :key="base_profile.id">
                  <a href="#" @click.prevent="control_switching_profile(base_profile)"
                    class="d-flex align-items-center gap-3 text-decoration-none text-dark p-2 rounded hover-bg-light">
                    <div class="profile-list-avatar">
                      <!-- Loop through profile_files and show all images -->
                      <div v-if="base_profile.profile_files?.length">
                        <img v-for="file in base_profile.profile_files"
                            :key="file.id"
                            :src="file.file.file_url"
                            class="profile-image rounded"
                            alt="Profile Picture">
                      </div>
                      <div v-else class="me-2 ms-2 d-flex align-items-center justify-content-center">
                        <i class="bi bi-person-circle fs-3 text-dark pointer">
                        </i>
                    </div>
                  </div>
                    <span class="text-xxs mb-2">{{ base_profile.profile_name || user_details.first_name }}</span>
                    <i v-if="is_base_profile_active(base_profile)" class="bx bx-check text-primary ms-auto"></i>
                  </a>
                </div>
 
 
              </div>
            </div>
<div class="">
  <!-- Header -->
  <div class="px-3 py-2 ">
    <h6 class="fw-bold text-xxs text-muted">User Settings</h6>
  </div>

  <div  v-if="visible_domain || cbo_domain">

  <!-- Create Business Profile -->
  <button
    v-if="can_create_business_profile"
    class="dropdown-item d-flex align-items-center"
    @click="open_company_profile_modal"

  >
    <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
      <i class="bi bi-briefcase"></i>
    </div>
    <span class="fw-bold text-xxs">Create Business Profile</span>
  </button>
 
  <!-- Manage Business -->
  <button
    v-if="visible_base_profiles.some(profile => matches_profile_type(profile, 'business'))"
    class="dropdown-item d-flex align-items-center"
    @click="open_manage_business_modal"
  >
    <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
      <i class="bx bx-cog"></i>
    </div>
    <span class="fw-bold text-xxs">Manage Business</span>
  </button>

  <button
    class="dropdown-item d-flex align-items-center"
    @click="$router.push('/my_orders')"
  >
    <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
      <i class="bi bi-bag-check"></i>
    </div>
    <span class="fw-bold text-xxs">My Orders/Requests</span>
  </button>

  </div>

  <!-- Notifications Toggle Button -->
 <button
    class="dropdown-item d-flex align-items-center justify-content-between"
    data-bs-toggle="modal"
    data-bs-target="#notificationSettingsModal"
  >
    <div class="d-flex align-items-center">
      <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
        <i class="bx bx-bell"></i>
      </div>
      <span class="fw-bold text-xxs"> Manage Notifications</span>
    </div>
  </button>
 
  <!-- Deactivate Account -->
  <button
  class="dropdown-item d-flex align-items-center"
  @click="confirm_deactivation"
  >
  <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
    <i class="bx bx-user-x"></i>
  </div>
  <span class="fw-bold text-xxs">Deactivate Account</span>
</button>

  <!-- Delete Account -->
  <button
  class="dropdown-item d-flex align-items-center text-danger"
  @click="confirm_account_deletion"
  >
  <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
    <i class="bx bx-trash"></i>
  </div>
  <span class="fw-bold text-xxs">Delete Account</span>
</button>
 
  <!-- Logout -->
  <button class="dropdown-item d-flex align-items-center" @click="logout_user">
    <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
      <i class="bx bx-log-out"></i>
    </div>
    <span class="fw-bold text-xxs">Log Out</span>
  </button>
</div>
 
 
 
 
          </div>
        </li>
      </ul>
 
 
 
      <!-- Auth Links (If No Token) -->



  <ul
  :class="[
      'navbar-nav d-flex flex-row justify-content-center w-100',
      token_exists ? 'd-none' : ''
    ]"
>
  <li class="nav-item me-2">
    <router-link
      v-if="!workbook_domain"
      class="btn btn-primary btn-sm text-white shadow-sm rounded nav-link"
      to="sign_up_finale"
    >
      Sign up
    </router-link>
  </li>
  <li class="nav-item">
    <a
      class="btn btn-primary btn-sm text-white shadow-sm rounded nav-link"
      href="/sign_in_Finale"
    >
      Login
    </a>
  </li>
</ul>

    </div>
  </div>
  <!-- Manage Business Modal -->
<div class="modal fade" id="manageBusinessModal" tabindex="-1" aria-labelledby="manageBusinessModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content text-xxs">
      <div class="modal-header">
        <h5 class="modal-title" id="manageBusinessModalLabel">Manage Business Profiles</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <ul class="list-group">
          <li v-for="profile in visible_base_profiles.filter(profile => matches_profile_type(profile, 'business'))"
              :key="profile.id"
              class="list-group-item d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center gap-2">
              <img v-if="profile.profile_image" :src="profile.profile_image" class="rounded-circle" style="width: 30px; height: 30px;" />
              <div v-else class="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center"
                   style="width: 30px; height: 30px;">
                   {{ (profile.profile_name && profile.profile_name.charAt(0)) || (user_details.first_name && user_details.first_name.charAt(0)) }}
                  </div>
              <span>{{ profile.profile_name || user_details.first_name }}</span>
            </div>
            <i class="bx bx-trash text-danger cursor-pointer"
               title="Delete profile"
               @click.prevent="delete_company_profile(profile.id)">
            </i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
 

<!-- Notification Settings Modal -->
<div
  class="modal fade"
  id="notificationSettingsModal"
  tabindex="-1"
  aria-labelledby="notificationSettingsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded shadow">
 
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title fw-bold text-sm" id="notificationSettingsModalLabel">
          Notification Settings
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
 
      <!-- Modal Body -->
      <div class="modal-body">
        <p class="text-muted small mb-3">
          Control how you receive updates and alerts from the platform.
        </p>
 
        <!-- Email Notifications -->
        <div class="d-flex justify-content-between align-items-center mb-3 p-3 border rounded">
          <div>
            <h6 class="mb-1">Email Notifications</h6>
            <small class="text-muted">Receive important updates via email.</small>
          </div>
          <div class="form-check ">
            <input
              class="form-check-input"
              type="checkbox"
              id="emailNotificationToggle"
              v-model="receive_emails"
            />
          </div>
        </div>
 
        <!-- In-App Notifications -->
        <div class="d-flex justify-content-between align-items-center mb-3 p-3 border rounded">
          <div>
            <h6 class="mb-1">In-App Notifications</h6>
            <small class="text-muted">Get notifications directly inside the app.</small>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="inAppNotificationToggle"
              v-model="receive_notifications"
            />
          </div>
        </div>
      </div>
 
      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary btn-sm text-xxs"
          @click="update_user_settings"
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>
 
 
 
 
  <!-- Second Row: Mobile Search Input -->
<div v-if="show_search" class="container-fluid home-nav-mobile-search-results">
  <!-- <input v-model="search_query" type="text" class="form-control p-1 mb-3 text-dark rounded shadow" placeholder="Search..." @click="show_recent"/> -->
 
  <div v-if="filtered_profiles"
       class="position-absolute top-100 start-0 end-0 p-0 bg-white shadow rounded-bottom overflow-auto z-3 col-sm ">
    <ul class="list-group">
 
      <!-- Recent Searches -->
      <li v-if="filtered_recent.length>0" class="list-group-item bg-light">
        <small class="text-muted fw-bold">Recent Searches</small>
      </li>
      <li v-if="filtered_recent.length>0"
          v-for="history in filtered_recent"
          :key="`history-${history.id}`"
          class="list-group-item d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-2">
          <i class="bx bx-history text-secondary"></i>
          <a @click="apply_history(history.query)" class="text-decoration-none text-dark">
            {{ history.query }}
          </a>
        </div>
        <button class="btn btn-sm btn-light text-danger border-0" @click.stop="remove_history(history.id)">
          <i class="bx bx-x"></i>
        </button>
      </li>
 
      <!-- People -->
      <li v-if="filtered_profiles.profiles?.length" class="list-group-item bg-light">
        <small class="text-muted fw-bold">People</small>
      </li>
      <li v-for="profile in filtered_profiles.profiles" :key="`profile-${profile.id}`" class="list-group-item">
        <div @click="view_profile(profile)" class="d-flex align-items-center gap-3 mx-3 pointer">
          <div class="profile-avatar">
            <i class='bx bxs-user-circle text-secondary fs-2'></i>
          </div>
          <div class="d-flex flex-column">
            <a class="text-decoration-none text-dark">
              {{ profile.user.first_name }} {{ profile.user.last_name }}
            </a>
            <small class="text-muted">{{ profile?.user.email || '' }}</small>
          </div>
        </div>
      </li>
 
      <!-- Companies -->
      <li v-if="filtered_profiles.companies?.length" class="list-group-item bg-light">
        <small class="text-muted fw-bold">Businesses</small>
      </li>
      <li v-for="company in filtered_profiles.companies" :key="`company-${company.id}`" class="list-group-item">
        <div class="d-flex align-items-center gap-3 mx-3">
          <i class='bx bxs-briefcase text-secondary fs-2'></i>
          <div class="d-flex flex-column">
            <a @click="view_profile(company)" class="text-decoration-none text-dark">
              {{ company.company_name }}
            </a>
            <small class="text-muted">{{ company?.location || '' }}</small>
          </div>
        </div>
      </li>
 
      <!-- Portals -->
      <li v-if="visible_portals.length" class="list-group-item bg-light">
        <small class="text-muted fw-bold">Portals</small>
      </li>
      <li v-for="portal in visible_portals" :key="`portal-${portal.id}`" class="list-group-item">
        <div class="d-flex align-items-center gap-3 mx-3">
          <i class="bx bx-globe text-secondary fs-2"></i>
          <div class="d-flex flex-column">
            <a @click="view_portal(portal)" class="text-decoration-none text-dark">
              {{ portal.portal_name || portal.name }}
            </a>
            <small class="text-muted">{{ portal?.description || '' }}</small>
          </div>
        </div>
      </li>
 
      <!-- Reports -->
      <li v-if="filtered_profiles.reports?.length" class="list-group-item bg-light">
        <small class="text-muted fw-bold">Reports</small>
      </li>
      <li v-for="report in filtered_profiles.reports" :key="`report-${report.id}`" class="list-group-item">
        <div class="d-flex align-items-center gap-3 mx-3">
          <i class="bx bx-file text-secondary fs-2"></i>
          <div class="d-flex flex-column">
            <a @click="view_report(report)" class="text-decoration-none text-dark">
              <span v-html="displayed_description(report)"></span>
            </a>
            <small class="text-muted">
              Tags:
              <span v-for="tag in report.tags" :key="tag.id">
                {{ tag.name }}
              </span>
            </small>
          </div>
        </div>
      </li>

      <!-- Products -->
      <li v-if="filtered_profiles.products?.length" class="list-group-item bg-light">
        <small class="text-muted fw-bold">Products</small>
      </li>
      <li v-for="product in filtered_profiles.products" :key="`product-${product.id}`" class="list-group-item">
        <div class="d-flex align-items-center gap-3 mx-3">
          <img
            :src="product.images?.length ? product.images[0].image_url : require('@/assets/images/image_placeholder.jpg')"
            :alt="product.name || 'Product image'"
            class="profile-image rounded profile-list-avatar object-fit-cover flex-shrink-0 mt-2"
          >
          <div class="d-flex flex-column">
            <a class="text-decoration-none text-dark pointer" @click="view_product_details(product)">
              {{ product.name }}
            </a>
          </div>
        </div>
      </li>
 
 
      <!-- Loading -->
      <li v-if="is_loading" class="list-group-item text-center">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </li>
 
      <!-- Empty State -->
      <li v-else-if="!filtered_profiles.profiles?.length &&
                     !filtered_profiles.companies?.length &&
                     !filtered_profiles.portals?.length &&
                     !filtered_profiles.reports?.length &&
                     !filtered_profiles.products?.length &&
                     !filtered_profiles.tags?.length &&
                     search_query"
          class="list-group-item text-center">
        <i class="bx bx-search-alt text-primary fs-4 d-block mb-1"></i>
        <span class="text-muted">No results found</span>
      </li>
 
    </ul>
  </div>
</div>
 
</nav>

<div v-if="profile_switch_loading" class="profile-switch-loader-backdrop">
  <div class="profile-switch-loader" role="status" aria-live="polite">
    <div class="profile-switch-loader-icon">
      <i class="bi bi-person-check-fill"></i>
    </div>
    <p class="profile-switch-loader-title">Switching profile</p>
    <p class="profile-switch-loader-text">Getting your workspace ready...</p>
    <div class="profile-switch-loader-dots" aria-hidden="true">
      <span></span><span></span><span></span>
    </div>
  </div>
</div>
 
<!-- <teleport to="body"> -->
  <div class="modal fade" id="company_profile_modal" tabindex="-1" aria-labelledby="company_profile_modallabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content shadow company-profile-modal-content">
          <div class="modal-header bg-primary position-relative">
          <p class="modal-title text-xxs text-white" id="company_profile_modallabel">
          {{ is_edit_mode ? 'Edit Business Profile' : 'Create Company Profile' }}
          </p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <div class="modal-body modal-body-scroll">
          <form @submit.prevent="is_edit_mode ? update_company_profile() : save_company_profile()" id="companyProfileForm" novalidate class="text-xxs">
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="company_name" class="form-label fw-500">Company Name<span class="text-danger">
                  *</span></label>
                <input type="text" class="form-control text-xxs rounded" id="company_name" v-model="company_name"
                  placeholder="Company name" :class="{ 'is-invalid': errors.company_name }">
                <p v-if="errors.company_name" class="text-danger text-xxs">{{ errors.company_name }}</p>
              </div>
              <div class="col-md-6">
                 <label for="type_of_organization" class="form-label fw-500">Type of Organisation<span class="text-danger">
                  *</span></label>
                <select class="form-control text-xxs rounded" id="type_of_organization"
                  v-model="selected_type_of_organization" :class="{ 'is-invalid': errors.type_of_organization_id }">
                  <option value="">Select Organisation Type</option>
                  <option v-for="type in type_of_organization" :key="type.id" :value="type.id">
                    {{ type.type_of_organization.replace('_', ' ').toUpperCase() }}
                  </option>
                </select>
                <p v-if="errors.type_of_organization_id" class="text-danger text-xxs mt-1">{{ errors.type_of_organization_id }}</p>
              </div>
            </div>

            <label for="description" class="form-label fw-500">Description<span class="text-danger"> *</span></label>
            <QuillEditor theme="snow" v-model="description" ref="quill_company_editor_ref" class="quill-editor"
              placeholder="Enter your description here..." toolbar="full" />

              <div class="row mt-3">
                <div class="col-md-6">
                  <label for="email" class="form-label fw-500">Company Email</label>
                  <input type="email" class="form-control text-xxs rounded" id="email" v-model="email"
                    placeholder="Company email" :class="{ 'is-invalid': errors.email }">
                  <p v-if="errors.email" class="text-danger text-xxs">{{ errors.email }}</p>
                </div>
                <div class="col-md-6">
                  <label for="tell_number" class="form-label fw-500">Company Telephone</label>
                  <input type="text" class="form-control text-xxs rounded" id="tell_number" v-model="tell_number"
                    placeholder="Telephone number" :class="{ 'is-invalid': errors.tell_number }">
                  <p v-if="errors.tell_number" class="text-danger text-xxs">{{ errors.tell_number }}</p>
                </div>
                <div class="col-md-6 mt-2">
                  <label for="company_street_address" class="form-label fw-500">Street Address</label>
                  <input id="company_street_address" type="text" class="form-control text-xxs rounded"
                    v-model="address_list.street_address" placeholder="Street address">
                </div>
                <div class="col-md-6 mt-2">
                  <label for="company_suburb" class="form-label fw-500">Suburb / Local Area</label>
                  <input id="company_suburb" type="text" class="form-control text-xxs rounded"
                    v-model="address_list.suburb" placeholder="Suburb or local area">
                </div>
                <div class="col-md-6 mt-2">
                  <label for="company_town" class="form-label fw-500">Town / City</label>
                  <input id="company_town" type="text" class="form-control text-xxs rounded"
                    v-model="address_list.town" placeholder="Town or city">
                </div>
                <div class="col-md-6 mt-2">
                  <label for="company_province" class="form-label fw-500">Province</label>
                  <input id="company_province" type="text" class="form-control text-xxs rounded"
                    v-model="address_list.province" placeholder="Province">
                </div>
                <div class="col-md-6 mt-2">
                  <label for="company_postal_code" class="form-label fw-500">Postal Code</label>
                  <input id="company_postal_code" type="text" class="form-control text-xxs rounded"
                    v-model="address_list.postal_code" placeholder="Postal code">
                </div>
</div>
          </form>
        </div>
        <div class="modal-footer company-profile-modal-footer bg-white">
          <button type="submit" form="companyProfileForm" class="btn btn-primary btn-sm text-white text-xxs shadow-sm rounded">
            {{ is_edit_mode ? 'Update' : 'Save' }}
          </button>
        </div>
      </div>
    </div>
  </div>
<!-- </teleport> -->
<StickyNav/>
